/**
 * Pair With — Carousel + Split Pane
 * Handles:
 *  - Carousel arrow navigation (prev/next)
 *  - Per-card image galleries (swipe / arrows / dots)
 *  - Tap a card image to open the full-size lightbox
 *  - Add to cart from carousel cards
 *  - Click product name to open split pane
 *  - Add to cart from pane → auto-suggest next product
 *  - Cart bar at top showing total + checkout link
 */
(function() {
  'use strict';

  var carousel = document.getElementById('PairWithCarousel');
  var pane = document.getElementById('PairPane');
  var backdrop = document.getElementById('PairPaneBackdrop');
  if (!carousel) return;

  var cards = carousel.querySelectorAll('.PairWith__Item');
  var prevArrow = document.querySelector('[data-pair-arrow="prev"]');
  var nextArrow = document.querySelector('[data-pair-arrow="next"]');

  // Pane elements
  var paneTitle = pane ? pane.querySelector('[data-pane-title]') : null;
  var paneBody = pane ? pane.querySelector('.PairPane__Body') : null;
  var paneAddBtn = pane ? pane.querySelector('[data-pane-add]') : null;
  var paneClose = pane ? pane.querySelector('[data-pane-close]') : null;
  var paneToast = pane ? pane.querySelector('[data-pane-toast]') : null;

  var currentPaneHandle = null;
  var currentPaneVariantId = null;
  var allPairProducts = [];

  // Gather product data from cards
  cards.forEach(function(card) {
    allPairProducts.push({
      handle: card.getAttribute('data-pair-handle'),
      variantId: card.getAttribute('data-pair-variant-id'),
      title: card.getAttribute('data-pair-title'),
      price: card.getAttribute('data-pair-price'),
      image: card.getAttribute('data-pair-image')
    });
  });

  // === CART STATE (which pair variants are already in the cart) ===
  var cartVariantIds = {};

  function isInCart(variantId) {
    return !!cartVariantIds[String(variantId)];
  }

  function loadCartState() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartVariantIds = {};
        (cart.items || []).forEach(function(it) {
          cartVariantIds[String(it.variant_id)] = true;
        });
        return cart;
      })
      .catch(function() { return null; });
  }

  // Refresh the live card list + arrows; hide the whole block when empty.
  function refreshCardsState() {
    cards = carousel.querySelectorAll('.PairWith__Item');
    updateArrows();
    if (cards.length === 0) {
      var wrap = carousel.closest('.PairWith');
      if (wrap) wrap.style.display = 'none';
    }
  }

  // Animate a card out, then drop it so the next item slides into view.
  function removeCard(card) {
    if (!card || !card.parentNode) return;
    card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
    card.style.opacity = '0';
    card.style.transform = 'scale(0.92)';
    setTimeout(function() {
      if (card.parentNode) card.parentNode.removeChild(card);
      refreshCardsState();
    }, 300);
  }

  function removeCardForVariant(variantId) {
    if (!variantId) return;
    var card = carousel.querySelector('.PairWith__Item[data-pair-variant-id="' + variantId + '"]');
    if (card) removeCard(card);
  }

  // Pane footer button state helpers.
  function setPaneAdded() {
    if (!paneAddBtn) return;
    paneAddBtn.textContent = 'ADDED \u2713';
    paneAddBtn.disabled = true;
    paneAddBtn.classList.add('is-added');
  }
  function setPaneAddable() {
    if (!paneAddBtn) return;
    paneAddBtn.textContent = 'ADD TO CART';
    paneAddBtn.disabled = false;
    paneAddBtn.classList.remove('is-added');
  }
  function updatePaneAddBtnState() {
    if (isInCart(currentPaneVariantId)) setPaneAdded();
    else setPaneAddable();
  }

  // On load, drop any pair items already sitting in the cart.
  loadCartState().then(function() {
    cards.forEach(function(card) {
      if (isInCart(card.getAttribute('data-pair-variant-id'))) {
        if (card.parentNode) card.parentNode.removeChild(card);
      }
    });
    refreshCardsState();
  });

  // === CAROUSEL ARROWS ===
  function updateArrows() {
    if (!prevArrow || !nextArrow) return;
    var scrollLeft = carousel.scrollLeft;
    var maxScroll = carousel.scrollWidth - carousel.clientWidth;
    prevArrow.disabled = scrollLeft < 10;
    nextArrow.disabled = scrollLeft >= maxScroll - 10;
  }

  if (prevArrow) {
    prevArrow.addEventListener('click', function() {
      var cardWidth = cards[0] ? (cards[0].offsetWidth + 12) : carousel.clientWidth;
      carousel.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    });
  }
  if (nextArrow) {
    nextArrow.addEventListener('click', function() {
      var cardWidth = cards[0] ? (cards[0].offsetWidth + 12) : carousel.clientWidth;
      carousel.scrollBy({ left: cardWidth, behavior: 'smooth' });
    });
  }

  carousel.addEventListener('scroll', updateArrows);
  updateArrows();

  // === AUTO-SLIDE ===
  // Advances one product at a time. Every way a shopper can show interest —
  // hovering, touching, opening a photo full screen, flicking through one
  // product's photos — holds it still. Reasons are counted in a set so two
  // overlapping pauses can't cancel each other out when the first one clears.
  var wrap = carousel.closest('.PairWith');
  var autoplayOn = wrap ? wrap.getAttribute('data-pair-autoplay') !== 'false' : true;
  var autoplaySeconds = wrap ? parseInt(wrap.getAttribute('data-pair-autoplay-seconds'), 10) : 4;
  if (!autoplaySeconds || isNaN(autoplaySeconds)) autoplaySeconds = 4;

  var autoplayTimer = null;
  var pauseReasons = {};
  var resumeTimer = null;

  function anyPause() {
    for (var k in pauseReasons) { if (pauseReasons[k]) return true; }
    return false;
  }

  function canScroll() {
    return carousel.scrollWidth - carousel.clientWidth > 8;
  }

  function advance() {
    if (anyPause() || !canScroll()) return;
    var step = cards[0] ? (cards[0].offsetWidth + 12) : carousel.clientWidth;
    var maxScroll = carousel.scrollWidth - carousel.clientWidth;
    if (carousel.scrollLeft >= maxScroll - 8) {
      carousel.scrollTo({ left: 0, behavior: 'smooth' });   // wrap round to the start
    } else {
      carousel.scrollBy({ left: step, behavior: 'smooth' });
    }
  }

  function startAutoplay() {
    if (!autoplayOn || autoplayTimer || anyPause()) return;
    autoplayTimer = setInterval(advance, autoplaySeconds * 1000);
  }

  function stopAutoplay() {
    if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; }
  }

  function pause(reason) {
    pauseReasons[reason] = true;
    stopAutoplay();
  }

  function resume(reason) {
    delete pauseReasons[reason];
    if (!anyPause()) startAutoplay();
  }

  // Interacting with a card's photos holds the carousel until they stop.
  function holdForInteraction() {
    pause('interaction');
    if (resumeTimer) clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function() { resume('interaction'); }, 6000);
  }

  if (autoplayOn && wrap) {
    // Someone reading it, in any input model
    wrap.addEventListener('mouseenter', function() { pause('hover'); });
    wrap.addEventListener('mouseleave', function() { resume('hover'); });
    wrap.addEventListener('focusin', function() { pause('focus'); });
    wrap.addEventListener('focusout', function() { resume('focus'); });
    wrap.addEventListener('touchstart', holdForInteraction, { passive: true });

    // Flicking through one product's photos, or driving the carousel by hand.
    // Capture phase on purpose: the gallery arrows call stopPropagation(), so a
    // normal bubbling listener here would never see the very clicks that most
    // clearly mean "I'm looking at this one".
    wrap.addEventListener('click', function(e) {
      if (e.target.closest('[data-pw-img], [data-pair-arrow], .PairWith__Track')) holdForInteraction();
    }, true);
    carousel.querySelectorAll('[data-pw-track]').forEach(function(track) {
      track.addEventListener('scroll', holdForInteraction, { passive: true });
    });

    // Don't animate off-screen, and honour a reduced-motion preference
    if (window.matchMedia) {
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduced.matches) pause('reduced-motion');
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) resume('offscreen');
        else pause('offscreen');
      }, { threshold: 0.2 }).observe(wrap);
    }
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) pause('tab-hidden');
      else resume('tab-hidden');
    });

    startAutoplay();
  }

  // === PER-CARD IMAGE GALLERIES ===
  // Each card holds its own scroll-snap track of that product's photos.
  // The track uses overscroll-behavior-x: contain so swiping photos never
  // drags the product carousel underneath it; products move via the header
  // arrows or by dragging the card's text area.
  function initCardGallery(media) {
    var track = media.querySelector('[data-pw-track]');
    if (!track) return;

    var slides = track.querySelectorAll('.PairWith__Slide');
    if (slides.length < 2) return;

    var dots = media.querySelectorAll('.PairWith__Dot');
    var prevBtn = media.querySelector('[data-pw-img="prev"]');
    var nextBtn = media.querySelector('[data-pw-img="next"]');

    function currentIndex() {
      if (!track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function syncUi() {
      var idx = Math.min(Math.max(currentIndex(), 0), slides.length - 1);
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === idx);
      }
      if (prevBtn) prevBtn.hidden = idx <= 0;
      if (nextBtn) nextBtn.hidden = idx >= slides.length - 1;
    }

    function goTo(idx) {
      if (idx < 0) idx = 0;
      if (idx > slides.length - 1) idx = slides.length - 1;
      track.scrollLeft = idx * track.clientWidth;
      // Some browsers report the new scrollLeft only after the smooth scroll
      // settles, so paint the UI from the intended index straight away.
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === idx);
      }
      if (prevBtn) prevBtn.hidden = idx <= 0;
      if (nextBtn) nextBtn.hidden = idx >= slides.length - 1;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(currentIndex() + 1);
      });
    }

    var scrollTimer = null;
    track.addEventListener('scroll', function() {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncUi, 60);
    }, { passive: true });

    syncUi();
  }

  carousel.querySelectorAll('.PairWith__Media').forEach(initCardGallery);

  // === IMAGE LIGHTBOX (tap a card photo) ===
  var lightbox = null;

  function closeLightbox() {
    resume('lightbox');
    if (!lightbox) return;
    var el = lightbox;
    lightbox = null;
    el.classList.remove('open');
    document.body.classList.remove('PairLightbox--open');
    setTimeout(function() {
      if (el.parentNode) el.parentNode.removeChild(el);
    }, 240);
  }

  function openLightbox(sources, startIndex, title, card) {
    if (!sources.length) return;
    closeLightbox();
    pause('lightbox');   // hold the carousel while a photo is open full screen

    var el = document.createElement('div');
    el.className = 'PairLightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    if (title) el.setAttribute('aria-label', title);

    var html = '<div class="PairLightbox__Track" data-lb-track>';
    sources.forEach(function(src, i) {
      html += '<div class="PairLightbox__Slide"><img class="PairLightbox__Img" src="' + escapeHtml(src) +
              '" alt="' + escapeHtml(title || '') + (sources.length > 1 ? ' — image ' + (i + 1) : '') + '"></div>';
    });
    html += '</div>';
    html += '<button type="button" class="PairLightbox__Close" data-lb-close aria-label="Close">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';
    if (sources.length > 1) {
      html += '<span class="PairLightbox__Counter" data-lb-counter></span>';
      html += '<button type="button" class="PairLightbox__Arrow PairLightbox__Arrow--prev" data-lb-arrow="prev" aria-label="Previous image">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg></button>';
      html += '<button type="button" class="PairLightbox__Arrow PairLightbox__Arrow--next" data-lb-arrow="next" aria-label="Next image">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg></button>';
      html += '<div class="PairLightbox__Dots">';
      sources.forEach(function(_, i) {
        html += '<button type="button" class="PairLightbox__Dot" data-lb-dot="' + i + '" aria-label="Go to image ' + (i + 1) + '"></button>';
      });
      html += '</div>';
    }

    // Buy bar: let a shopper add the product without closing the photo first.
    var variantId = card ? card.getAttribute('data-pair-variant-id') : null;
    var cardAddBtn = card ? card.querySelector('[data-pairwith-add]') : null;
    var soldOut = cardAddBtn ? cardAddBtn.disabled : false;

    if (variantId) {
      var price = card.getAttribute('data-pair-price') || '';
      var alreadyIn = isInCart(variantId);
      var label = soldOut ? 'Sold Out' : (alreadyIn ? 'Added ✓' : 'Add to cart');

      el.classList.add('PairLightbox--withBar');
      html += '<div class="PairLightbox__Bar">' +
                '<div class="PairLightbox__Info">' +
                  '<span class="PairLightbox__Name">' + escapeHtml(title || '') + '</span>' +
                  (price ? '<span class="PairLightbox__Price">' + escapeHtml(price) + '</span>' : '') +
                '</div>' +
                '<button type="button" class="PairLightbox__Add' + (alreadyIn ? ' is-added' : '') + '"' +
                  ' data-lb-add' + ((soldOut || alreadyIn) ? ' disabled' : '') + '>' + label + '</button>' +
              '</div>';
    }

    el.innerHTML = html;

    document.body.appendChild(el);
    document.body.classList.add('PairLightbox--open');
    lightbox = el;

    var track = el.querySelector('[data-lb-track]');
    var dots = el.querySelectorAll('[data-lb-dot]');
    var counter = el.querySelector('[data-lb-counter]');
    var prevArrow = el.querySelector('[data-lb-arrow="prev"]');
    var nextArrow = el.querySelector('[data-lb-arrow="next"]');

    function lbIndex() {
      if (!track.clientWidth) return 0;
      return Math.min(Math.max(Math.round(track.scrollLeft / track.clientWidth), 0), sources.length - 1);
    }

    function paint(idx) {
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === idx);
      }
      if (counter) counter.textContent = (idx + 1) + ' / ' + sources.length;
      if (prevArrow) prevArrow.hidden = idx <= 0;
      if (nextArrow) nextArrow.hidden = idx >= sources.length - 1;
    }

    function lbGoTo(idx, instant) {
      if (idx < 0) idx = 0;
      if (idx > sources.length - 1) idx = sources.length - 1;
      var previous = track.style.scrollBehavior;
      if (instant) track.style.scrollBehavior = 'auto';
      track.scrollLeft = idx * track.clientWidth;
      if (instant) track.style.scrollBehavior = previous;
      paint(idx);
    }

    if (prevArrow) prevArrow.addEventListener('click', function() { lbGoTo(lbIndex() - 1); });
    if (nextArrow) nextArrow.addEventListener('click', function() { lbGoTo(lbIndex() + 1); });
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { lbGoTo(parseInt(dot.getAttribute('data-lb-dot'), 10)); });
    });

    var lbScrollTimer = null;
    track.addEventListener('scroll', function() {
      if (lbScrollTimer) clearTimeout(lbScrollTimer);
      lbScrollTimer = setTimeout(function() { paint(lbIndex()); }, 60);
    }, { passive: true });

    var lbAdd = el.querySelector('[data-lb-add]');
    if (lbAdd && !lbAdd.disabled) {
      lbAdd.addEventListener('click', function() {
        if (lbAdd.disabled) return;
        lbAdd.disabled = true;
        lbAdd.textContent = 'Adding…';

        addToCart(variantId).then(function() {
          lbAdd.textContent = 'Added ✓';
          lbAdd.classList.add('is-added');
          // Same behaviour as adding from the card: drop it from the carousel,
          // then step out of the photo so they can carry on browsing.
          removeCardForVariant(variantId);
          setTimeout(closeLightbox, 900);
        }).catch(function() {
          lbAdd.textContent = 'Error — retry';
          lbAdd.disabled = false;
        });
      });
    }

    el.querySelector('[data-lb-close]').addEventListener('click', closeLightbox);
    // Clicking the backdrop around the photo closes too; the photo itself does not.
    el.addEventListener('click', function(e) {
      if (e.target === el || e.target.classList.contains('PairLightbox__Slide')) closeLightbox();
    });
    // Bound to THIS overlay: once it is gone (closed, or replaced by a newer
    // one) the handler retires instead of driving a detached element.
    document.addEventListener('keydown', function handler(e) {
      if (lightbox !== el) { document.removeEventListener('keydown', handler); return; }
      if (e.key === 'Escape') { closeLightbox(); document.removeEventListener('keydown', handler); }
      else if (e.key === 'ArrowRight') lbGoTo(lbIndex() + 1);
      else if (e.key === 'ArrowLeft') lbGoTo(lbIndex() - 1);
    });

    // Jump to the tapped photo without animating in from image 1.
    requestAnimationFrame(function() {
      lbGoTo(startIndex, true);
      el.classList.add('open');
    });
  }

  carousel.addEventListener('click', function(e) {
    var img = e.target.closest('.PairWith__Img[data-pw-zoom]');
    if (!img) return;
    e.preventDefault();

    var card = img.closest('.PairWith__Item');
    if (!card) return;

    var all = Dom_toArray(card.querySelectorAll('.PairWith__Img[data-pw-zoom]'));
    var sources = all.map(function(node) { return node.getAttribute('data-pw-zoom'); });
    openLightbox(sources, all.indexOf(img), card.getAttribute('data-pair-title'), card);
  });

  function Dom_toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  // === ADD TO CART (from carousel cards) ===
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-pairwith-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-pairwith-add');
    if (!variantId) return;

    var original = btn.textContent;
    btn.textContent = 'Added ✓';
    btn.disabled = true;

    addToCart(variantId).then(function() {
      // Confirm briefly, then remove this card so the next one slides into view.
      var card = btn.closest('.PairWith__Item');
      setTimeout(function() { removeCard(card); }, 700);
    }).catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() {
        btn.disabled = false;
        btn.textContent = original;
      }, 1500);
    });
  });

  // === OPEN SPLIT PANE (click product image or name) ===
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-pair-view]');
    if (!trigger) return;
    e.preventDefault();
    var handle = trigger.getAttribute('data-pair-view');
    if (handle) openPane(handle);
  });

  function openPane(handle) {
    if (!pane) return;
    pause('pane');
    pane.classList.add('open');
    if (backdrop) backdrop.classList.add('open');
    currentPaneHandle = handle;

    // Find product data
    var prod = allPairProducts.find(function(p) { return p.handle === handle; });
    if (paneTitle) paneTitle.textContent = prod ? prod.title : handle.replace(/-/g, ' ');

    // Show loading
    paneBody.innerHTML = '<div class="PairPane__Toast" data-pane-toast><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg><span>Added to cart</span></div><div class="PairPane__Loading"><div class="PairPane__Spinner"></div></div>';
    if (paneAddBtn) {
      paneAddBtn.disabled = true;
      paneAddBtn.textContent = 'ADD TO CART';
      paneAddBtn.classList.remove('is-added');
    }

    // Fetch full product data
    fetch('/products/' + encodeURIComponent(handle) + '.json')
      .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function(data) {
        var product = data.product;
        currentPaneVariantId = product.variants[0] ? product.variants[0].id : null;
        renderPaneProduct(product);
        updatePaneAddBtnState();
      })
      .catch(function() {
        // Fallback: use local data
        if (prod) {
          currentPaneVariantId = prod.variantId;
          paneBody.innerHTML = '<div class="PairPane__Toast" data-pane-toast><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg><span>Added to cart</span></div>' +
            (prod.image ? '<img class="PairPane__Image" src="' + escapeHtml(prod.image) + '" alt="' + escapeHtml(prod.title) + '">' : '') +
            '<div class="PairPane__Detail"><div class="PairPane__ProdName">' + escapeHtml(prod.title) + '</div><div class="PairPane__PriceText">' + escapeHtml(prod.price) + '</div></div>';
          updatePaneAddBtnState();
        } else {
          paneBody.innerHTML = '<div style="padding:40px 16px;text-align:center;color:#888;font-size:13px;">Could not load product.</div>';
        }
      });
  }

  function renderPaneProduct(product) {
    var images = product.images || [];
    var variant = product.variants[0];
    var price = variant ? ('$' + parseFloat(variant.price).toFixed(2)) : '';
    var desc = product.body_html || '';

    // Sanitize description (strip scripts)
    var tmp = document.createElement('div');
    tmp.innerHTML = desc;
    tmp.querySelectorAll('script,iframe,object,embed').forEach(function(el) { el.remove(); });
    desc = tmp.innerHTML;

    var html = '<div class="PairPane__Toast" data-pane-toast><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg><span>Added to cart</span></div>';

    // Image gallery
    if (images.length > 0) {
      html += '<div class="PairPane__Gallery">';
      html += '<div class="PairPane__GalleryTrack">';
      images.forEach(function(img, i) {
        html += '<div class="PairPane__GallerySlide" data-slide="' + i + '">';
        html += '<img src="' + escapeHtml(img.src) + '" alt="' + escapeHtml(product.title) + ' - image ' + (i+1) + '" class="PairPane__GalleryImg" data-zoom-src="' + escapeHtml(img.src) + '">';
        html += '</div>';
      });
      html += '</div>';
      if (images.length > 1) {
        html += '<button type="button" class="PairPane__GalleryArrow PairPane__GalleryArrow--prev" data-gallery-prev aria-label="Previous image"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg></button>';
        html += '<button type="button" class="PairPane__GalleryArrow PairPane__GalleryArrow--next" data-gallery-next aria-label="Next image"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 6 15 12 9 18"/></svg></button>';
        html += '<div class="PairPane__GalleryDots">';
        images.forEach(function(_, i) {
          html += '<span class="PairPane__GalleryDot' + (i === 0 ? ' active' : '') + '" data-dot="' + i + '"></span>';
        });
        html += '</div>';
      }
      html += '</div>';
    }

    html += '<div class="PairPane__Detail">';
    html += '<div class="PairPane__ProdName">' + escapeHtml(product.title) + '</div>';
    html += '<div class="PairPane__PriceText">' + price + '</div>';
    if (desc) html += '<div class="PairPane__Desc">' + desc + '</div>';
    html += '</div>';

    paneBody.innerHTML = html;
    paneToast = pane.querySelector('[data-pane-toast]');

    // Init gallery
    initPaneGallery();
  }

  function initPaneGallery() {
    var gallery = paneBody.querySelector('.PairPane__Gallery');
    if (!gallery) return;

    var track = gallery.querySelector('.PairPane__GalleryTrack');
    var slides = gallery.querySelectorAll('.PairPane__GallerySlide');
    var dots = gallery.querySelectorAll('.PairPane__GalleryDot');
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var currentSlide = 0;

    function goToSlide(idx) {
      if (idx < 0) idx = 0;
      if (idx >= slides.length) idx = slides.length - 1;
      currentSlide = idx;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      dots.forEach(function(d, i) {
        d.classList.toggle('active', i === idx);
      });
      if (prevBtn) prevBtn.style.display = idx === 0 ? 'none' : '';
      if (nextBtn) nextBtn.style.display = idx >= slides.length - 1 ? 'none' : '';
    }

    if (prevBtn) prevBtn.addEventListener('click', function(e) { e.stopPropagation(); goToSlide(currentSlide - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function(e) { e.stopPropagation(); goToSlide(currentSlide + 1); });
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { goToSlide(parseInt(dot.getAttribute('data-dot'))); });
    });

    // Swipe support
    var startX = 0, deltaX = 0, swiping = false;
    track.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      deltaX = 0;
      swiping = true;
    }, { passive: true });
    track.addEventListener('touchmove', function(e) {
      if (!swiping) return;
      deltaX = e.touches[0].clientX - startX;
    }, { passive: true });
    track.addEventListener('touchend', function() {
      if (!swiping) return;
      swiping = false;
      if (Math.abs(deltaX) > 40) {
        if (deltaX < 0) goToSlide(currentSlide + 1);
        else goToSlide(currentSlide - 1);
      }
    });

    // Tap to zoom
    slides.forEach(function(slide) {
      slide.addEventListener('click', function() {
        var img = slide.querySelector('img');
        if (!img) return;
        openZoom(img.getAttribute('data-zoom-src') || img.src);
      });
    });

    goToSlide(0);
  }

  function openZoom(src) {
    var overlay = document.createElement('div');
    overlay.className = 'PairPane__ZoomOverlay';
    overlay.innerHTML = '<img src="' + escapeHtml(src) + '" class="PairPane__ZoomImg"><button type="button" class="PairPane__ZoomClose" aria-label="Close zoom">&times;</button>';
    document.body.appendChild(overlay);

    // Animate in
    requestAnimationFrame(function() { overlay.classList.add('open'); });

    function closeZoom() {
      overlay.classList.remove('open');
      setTimeout(function() { overlay.remove(); }, 250);
    }

    overlay.querySelector('.PairPane__ZoomClose').addEventListener('click', closeZoom);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeZoom();
    });
    document.addEventListener('keydown', function handler(e) {
      if (e.key === 'Escape') { closeZoom(); document.removeEventListener('keydown', handler); }
    });
  }

  function closePane() {
    resume('pane');
    if (pane) pane.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    currentPaneHandle = null;
    currentPaneVariantId = null;
  }

  if (paneClose) paneClose.addEventListener('click', closePane);
  if (backdrop) backdrop.addEventListener('click', closePane);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && pane && pane.classList.contains('open')) closePane();
  });

  // === ADD TO CART FROM PANE ===
  if (paneAddBtn) {
    paneAddBtn.addEventListener('click', function() {
      if (!currentPaneVariantId || paneAddBtn.disabled) return;
      paneAddBtn.disabled = true;
      paneAddBtn.textContent = 'ADDING...';

      addToCart(currentPaneVariantId).then(function() {
        setPaneAdded();

        // Remove this product's card from the carousel list.
        removeCardForVariant(currentPaneVariantId);

        // The cart drawer now opens on every add. Two full-height overlays
        // stacked on a phone is unreadable, so the pane steps aside and lets the
        // cart be the one thing on screen. Its own toast and "also pairs well"
        // list are skipped here for the same reason — both would render behind
        // the drawer where nobody would see them.
        closePane();
      }).catch(function() {
        paneAddBtn.textContent = 'ERROR — RETRY';
        paneAddBtn.disabled = false;
        setTimeout(function() { paneAddBtn.textContent = 'ADD TO CART'; }, 2000);
      });
    });
  }

  // DORMANT since 2 Sep 2026: the pane closes on add so the cart drawer can be
  // seen, which leaves nothing to append this to. Kept, not deleted — if the
  // pane ever goes back to staying open on add, this is the flow to restore.
  function suggestNext() {
    // Find next products that aren't the current one and aren't already in the cart.
    var others = allPairProducts.filter(function(p) {
      return p.handle !== currentPaneHandle && !isInCart(p.variantId);
    });
    if (others.length === 0) return;

    var suggestDiv = document.createElement('div');
    suggestDiv.className = 'PairPane__Suggest';
    suggestDiv.innerHTML = '<div class="PairPane__SuggestLabel">Also pairs well</div>';
    others.forEach(function(p) {
      var item = document.createElement('div');
      item.className = 'PairPane__SuggestItem';
      item.setAttribute('data-suggest-handle', p.handle);
      item.innerHTML = (p.image ? '<img src="' + escapeHtml(p.image.replace('600x600', '100x100')) + '" alt="' + escapeHtml(p.title) + '">' : '') +
        '<span>' + escapeHtml(p.title) + '</span>';
      suggestDiv.appendChild(item);
    });

    // Append to body
    var existing = paneBody.querySelector('.PairPane__Suggest');
    if (existing) existing.remove();
    paneBody.appendChild(suggestDiv);

    // Scroll to bottom
    paneBody.scrollTop = paneBody.scrollHeight;

    // Click to open that product in pane
    suggestDiv.querySelectorAll('[data-suggest-handle]').forEach(function(item) {
      item.addEventListener('click', function() {
        openPane(item.getAttribute('data-suggest-handle'));
      });
    });
  }

  // DORMANT since 2 Sep 2026 — see the note on suggestNext().
  function showPaneToast(msg) {
    var toast = pane.querySelector('[data-pane-toast]');
    if (!toast) return;
    var span = toast.querySelector('span');
    if (span) span.textContent = msg;
    toast.classList.add('show');
    setTimeout(function() { toast.classList.remove('show'); }, 2500);
  }

  // The cart bar that used to live here queried #PairCartBar, [data-pair-cart-count]
  // and [data-pair-cart-total] — none of which any template has ever rendered —
  // plus .js-cart-count / [data-cart-count] / .Header__CartCount, which this theme
  // does not use either. It ran a /cart.js request on every add and did nothing
  // with the answer. theme.js already keeps .Header__CartDot in sync, and the
  // sticky cart bar covers the rest, so the whole block is gone rather than fixed.

  // === SHARED: Add to cart ===
  function addToCart(variantId) {
    var id = parseInt(variantId, 10);
    if (!id || isNaN(id)) return Promise.reject(new Error('Invalid variant'));
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Failed');
      return r.json();
    })
    .then(function(data) {
      cartVariantIds[String(id)] = true;
      // 2 Sep 2026 — this used to fire 'cart:refresh', which re-renders the cart
      // silently and deliberately did NOT open the drawer, so the pane would not
      // be covered. In practice that left a shopper with no feedback at all: she
      // tapped Add, the button said "Added", and nothing else on the page moved.
      // People were reaching checkout without knowing what was in the bag.
      // Confirmation beats an uninterrupted browse, so we now fire the theme's
      // real add event, which re-renders AND opens the drawer.
      //
      // detail.quantity is not optional: the theme does `itemCount += detail.quantity`,
      // so leaving it out sets the header cart count to NaN.
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { quantity: 1 }
      }));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return data;
    });
  }

  // === HELPERS ===

  function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

})();
